import { ReactNode } from 'react';

import { ITechnicianData } from 'services/config/types';
import { Roles } from 'constants/roles';

export enum SideBarItemTypes {
  Home = 'home',
  Tickets = 'tickets',
  Chats = 'chats',
  Invoices = 'invoices',
}

export interface ISideBarItem {
  id: SideBarItemTypes
  icon: ReactNode;
  title: string;
  path: string;
  roles: Roles[];
}

export interface ITechnicianDataFields {
  name: keyof ITechnicianData;
  label: string;
}
